/**
 * @desc 贴标管理-导出交货单已绑定的箱子
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(dono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierDeliveryOrder/export/${dono}`, {
      method: "GET",

      ...options,
    }),
  );
}
